import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProductPreviewPageRoutingModule } from './product-preview-routing.module';

import { ProductPreviewPage } from './product-preview.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProductPreviewPageRoutingModule
  ],
  declarations: [ProductPreviewPage]
})
export class ProductPreviewPageModule {}
